import { FC, useContext, useEffect } from "react";
import { CaseActionTypeEnum } from "Enums";
import { ICasePhaseAction } from "Interfaces";
import { CaseContext } from "Stores";

type TCasePhaseWrapperProps = {
    phaseName: string,
    children: JSX.Element | JSX.Element[];
}

export const CasePhaseWrapper: FC<TCasePhaseWrapperProps> = ({phaseName, children}: TCasePhaseWrapperProps) => {
    // Shared states
    const { caseState, caseDispatch } = useContext(CaseContext);

    useEffect(() => {
        if(caseState.casePhase.toLowerCase() !== phaseName.toLowerCase()) {
            caseDispatch({ type: CaseActionTypeEnum.SetCasePhase, casePhase: phaseName } as ICasePhaseAction);
        }
    }, [phaseName, caseState, caseDispatch]);

    return (
        <>
            {children}
        </>
    );
}